<template>

    <div class="input-simulator-container">

        <div class="flex-row middle-xs">
            <div class="col-xs-12 col-sm-8">
                <div class="label-container">
                    <span class="label-icon">
                        <slot name="icon"><i class="material-icons icon simulador-icon">{{ icon }}</i></slot>
                    </span>
                    <div>
                        <slot name="label">
                            <label>{{ label }}</label>
                            <div class="description" v-if="description">{{ description }}</div>
                        </slot>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-4">
                <slot name="input" v-bind="{placeholder, currentValue}">
                    <div v-if="inputType == 'percent'" class="input-percent">
                        <input step="0.1" max="100" min="0" type="number" class="form-control" v-model.number="currentValue" :placeholder="placeholder">
                    </div>
                    <div v-else-if="inputType == 'price'" class="input-money">
                        <money type="text" class="form-control" v-model.lazy="currentValue" :placeholder="placeholder" />
                    </div>
                    <div v-else>
                        <input :max="max" type="number" class="form-control" v-model.number="currentValue" :placeholder="placeholder">
                    </div>
                </slot>
            </div>
        </div>
    </div>

</template>

<script>

import "@/../static/assets/css/custom/flex.css";

export default {
    name: 'input-simulador',

    props: {
        label: String,
        value: Number,
        placeholder: String,
        description: String,
        icon: {
            type: String,
            default: 'attach_money'
        },
        inputType: {
            type: String,
            validator(value) {
                return ["percent", "price", "number"].includes(value)
            }
        },
        max: {
            value: Number,
            default: undefined
        }
    },

    data() {
        return {
            currentValue: null,
        }
    },

    methods: {
        changeValue() {
            this.$emit('input', parseFloat(this.currentValue));
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.currentValue = value
            }
        },
        currentValue(v)
        {
            console.log({v})
            this.changeValue()
        }
    },
}
</script>


<style lang="scss" scoped>
.label-container{
    display: flex;
    align-items: center;

    label{
        font-size: 14px;
    }


    .description{
        font-size: 12px;
        color: #bbb;
    }
}

.input-simulator-container{
    margin-bottom: 15px;

    .input-money::before,
    .input-percent::before{
        top: 50% !important;
    }
    .form-control{
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/InputSimulador.vue